import * as React from 'react';
import classnames from 'classnames';

import { ReferralSteps } from '@src/routes/common/components/ReferralSteps';

import styles from './styles.module.css';

export interface ReferIntroductionProps {
  className?: string;
}

/**
 * @name ReferIntroduction
 * @description Introduction to our referrals program
 */
export const ReferIntroduction = (props: ReferIntroductionProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames(styles.component, className);
  const cssSteps = classnames(styles.steps);

  return (
    <div className={cssComponent}>
      <div className="ui-container-lg">
        <h1 className={styles.heading}>Friends share (skincare) secrets</h1>
        <p className={styles.copy}>
          Tell your friends about Haldi and earn free skincare.
        </p>
        <ReferralSteps className={cssSteps} />
      </div>
    </div>
  );
};
